import React from "react";

interface PasswordStrengthIndicatorProps {
    password: string;
}

const getPasswordStrength = (password: string) => {
    const lengthScore = password.length >= 12 ? 3 : password.length >= 10 ? 2 : password.length >= 8 ? 1 : 0;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /[0-9]/.test(password);
    const hasSpecialChars = /[!@#$%^&*()_+[\]{}|;:,.<>?]/.test(password);

    const varietyScore = [hasUpperCase, hasLowerCase, hasNumbers, hasSpecialChars].filter(Boolean).length;
    const totalScore = lengthScore + varietyScore;

    if (totalScore >= 5) return { label: "Very Strong 🔥", color: "#4CAF50" }; // Green
    if (totalScore === 4) return { label: "Strong 💪", color: "#2196F3" }; // Blue
    if (totalScore === 3) return { label: "Medium ⚠️", color: "#FFC107" }; // Yellow
    return { label: "Weak ❌", color: "#F44336" }; // Red
};

const PasswordStrengthIndicator: React.FC<PasswordStrengthIndicatorProps> = ({ password }) => {
    if (!password) return null; // Hide if no password is provided

    const { label, color } = getPasswordStrength(password);

    return (
        <div style={{ fontWeight: "bold", marginTop: "10px", color }}>
            Strength: {label}
        </div>
    );
};

export default PasswordStrengthIndicator;
